import Certification from './Certification';
import CertificationFragment from './CertificationFragment';
import { flattenConnection } from '../../../util/functions';
import { titleCase } from '../../../util/strings';

export default {
    label: 'Certification',
    component: Certification,
    fragment: CertificationFragment,
    onLoad: data => {
        flattenConnection(data, 'AuthorisedContacts');
        (data.AuthorisedContacts || []).forEach(contact => {
            contact.Role = ('' + (contact.Role || ''))
                .split(',')
                .map(role => role.trim())
                .filter(Boolean);
        });
    },
    formatSaveData: (saveData, state) => {
        (saveData.AuthorisedContacts || []).forEach(contact => {
            if (Array.isArray(contact.Role)) contact.Role = contact.Role.join(', ');
        });

        if (saveData.FuneralFundName?.ID) saveData.FuneralFundName = titleCase(state.FuneralFundName.Name);
        if (saveData.LegacyDocuments) {
            saveData.LegacyDocuments = saveData.LegacyDocuments.map(({ ID }) => ({ ID }));
        }
    },
    validation: {
        required: [],
        suggested: [],
        onValidate: {}
    }
};
